import { render, staticRenderFns } from "./ListShiftWorkCongfig.vue?vue&type=template&id=4612e6ed&scoped=true"
import script from "./ListShiftWorkCongfig.vue?vue&type=script&lang=js"
export * from "./ListShiftWorkCongfig.vue?vue&type=script&lang=js"
import style0 from "./ListShiftWorkCongfig.vue?vue&type=style&index=0&id=4612e6ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612e6ed",
  null
  
)

export default component.exports